(function ($) {
    $.fn.smartbutton = function () {

        return this.each(function () {
            var mySmartbutton = $(this);
            var elements = $(this).parent('form').find(':input');
            var serialize = $(mySmartbutton).parent('form').serialize();

            $(mySmartbutton).bind('refresh', function () {
                if (serialize == $(mySmartbutton).parent('form').serialize()) {
                    $(mySmartbutton).attr('disabled', 'disabled')
                        .removeClass('app-button-primary')
                        .addClass('app-button-secondary');
                } else {
                    $(mySmartbutton)
                        .removeAttr('disabled')
                        .removeClass('app-button-secondary')
                        .addClass('app-button-primary');
                }
            }).trigger('refresh');

            elements.bind('change',function(){
                $(mySmartbutton).trigger('refresh');
            });

            return mySmartbutton;
        });
    };

}(jQuery));
